import { render, staticRenderFns } from "./STable.vue?vue&type=template&id=c5b8b8a2&scoped=true&"
import script from "./STable.vue?vue&type=script&lang=ts&"
export * from "./STable.vue?vue&type=script&lang=ts&"
import style0 from "./STable.vue?vue&type=style&index=0&id=c5b8b8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b8b8a2",
  null
  
)

export default component.exports